import { render, staticRenderFns } from "./AssetImageUploader.vue?vue&type=template&id=04f40e46&scoped=true&"
import script from "./AssetImageUploader.vue?vue&type=script&lang=js&"
export * from "./AssetImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./AssetImageUploader.vue?vue&type=style&index=0&id=04f40e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f40e46",
  null
  
)

export default component.exports